// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1BkvZ","onlyIcon":"_2ChKb","dsersIconButton":"_2dQOK","tinyPadding":"uj6wg","buttonContent":"qD12c"};